// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import TasksFilters from './data'

export default function TasksFiltersFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/TasksFilters">
      <TasksFilters {...props}>
        {children}
      </TasksFilters>
    </Flow>
  )
}
